import { EditableTitle, WImage, WLink } from '@components/atoms'
import { ArrowRight } from '@components/icons'
import { MenuItemType } from '@utils/types'
import styles from './AnchorCard.module.sass'

interface Props {
  className?: string
  item: MenuItemType
  editMode?: boolean
}

const AnchorCard = (props: Props) => {
  const { className = '', item = undefined, editMode = false } = props

  const getContent = () => (
    <>
      <div className={styles.imageBox}>
        <WImage
          className={styles.image}
          maxWidth={250}
          maxHeight={100}
          src={item.image}
          objectFit="cover"
        />
      </div>
      <div className={styles.main}>
        <div className={styles.head}>
          <EditableTitle title={item.name} editMode={editMode} className={styles.title} />
          <span className={styles.icon}>
            <ArrowRight className={styles.icon} />
          </span>
        </div>
        <EditableTitle title={item.intro} editMode={editMode} className={styles.subtitle} />
      </div>
    </>
  )

  return item || editMode ? (
    item.url && !editMode ? (
      <WLink href={item.url} newPage={item.blank} className={`${styles.root} ${className}`}>
        {getContent()}
      </WLink>
    ) : (
      <div className={`${styles.root} ${className}`}>{getContent()}</div>
    )
  ) : (
    <></>
  )
}

export default AnchorCard
